import { render } from "./CartItems.vue?vue&type=template&id=6382e9e6"
import script from "./CartItems.vue?vue&type=script&lang=js"
export * from "./CartItems.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__